export const QA_NAME_EMAIL_PROFILE_UNAVAILABLE = 'emailProfileUnavailable'

export const EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_ACTION_NAME = 'navigation'
